import checkapply from '@/view/check-apply';

const check = {
    install:function (Vue) {
        Vue.component('check',checkapply)
    }
}
export default check;